// extracted by mini-css-extract-plugin
export var boxItems = "_af-1";
export var boxItemsLg = "_af-2";
export var button = "_af-7";
export var buttonHoverless = "_af-9";
export var buttonLg = "_af-8";
export var filterGroupBox = "_af-0";
export var icon = "_af-3";
export var iconSecondary = "_af-6";
export var iconWrapper = "_af-4";
export var iconWrapperLg = "_af-5";
export var truncatedLabel = "_af-a";